import React, { FC, memo } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import useLastCallback from '../../hooks/useLastCallback';
import { ERoutes } from '../../types';
import { GlobalState } from '../../global/types';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';

import IconSvg from '../ui/IconSvg';
import classNames from 'classnames';
import MailImg from '../../assets/images/IntroLetter.svg';
import { withGlobal } from '../../global';
import { AuthOAuth } from './AuthOAuth';

type StateProps = Pick<GlobalState, 'authState' | 'twoFaSettings'>;

const AuthSignIn: FC<StateProps> = ({ authState, twoFaSettings }) => {
  const { t } = useTranslation();

  const { tab } = useParams();
  const navigate = useNavigate();

  console.log('AuthSignIn', tab, tab === ERoutes.signUp);

  const handleSetTab = useLastCallback(() => {
    navigate(
      `${ERoutes.auth}/${
        tab === ERoutes.signUp ? ERoutes.signIn : ERoutes.signUp
      }`
    );
  });

  return (
    <div
      id='auth-password-form'
      className='auth-password-center auth-password-form'
    >
      <div className='auth-form'>
        <div className='btn-group tab-nav'>
          <button
            type='button'
            className={classNames('Button text primary', {
              active: tab !== ERoutes.signUp,
            })}
            onClick={handleSetTab}
          >
            {t('Login.sign_in')}
          </button>
          <button
            type='button'
            className={classNames('Button text primary', {
              active: tab === ERoutes.signUp,
            })}
            onClick={handleSetTab}
          >
            {t('Login.sign_up')}
          </button>
        </div>
        <div className='login-title' role='img'>
          <IconSvg name='ello-title' w='104' h='24' />
        </div>
        <div className='transition-block'>
          {tab === ERoutes.signUp ? <SignUpForm /> : <SignInForm />}
          <AuthOAuth nonce={twoFaSettings.nonce} />
        </div>
      </div>
      <div
        className={classNames('mail-sent', {
          show: authState === 'authorizationStateWaitToken',
        })}
      >
        <img src={MailImg} alt='' />
        <h2>Your secure login is on the way!</h2>
        <p>
          If it doesn’t show up soon, take a peek in your spam or junk folder —
          just in case.
        </p>
      </div>
    </div>
  );
};

export default memo(
  withGlobal((global): StateProps => {
    const { authState, twoFaSettings } = global;
    return { authState, twoFaSettings };
  })(AuthSignIn)
);
